/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Low_Credit_BannerInputs */

const en_low_credit_banner = /** @type {(inputs: Low_Credit_BannerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`You have ${i?.count} AI actions left this month.`)
};

const de_low_credit_banner = /** @type {(inputs: Low_Credit_BannerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Du hast noch ${i?.count} KI-Aktionen diesen Monat übrig.`)
};

const fr_low_credit_banner = /** @type {(inputs: Low_Credit_BannerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Il te reste ${i?.count} actions IA ce mois-ci.`)
};

const es_low_credit_banner = /** @type {(inputs: Low_Credit_BannerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Te quedan ${i?.count} acciones de IA este mes.`)
};

const it_low_credit_banner = /** @type {(inputs: Low_Credit_BannerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hai ${i?.count} azioni IA rimanenti questo mese.`)
};

const nl_low_credit_banner = /** @type {(inputs: Low_Credit_BannerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Je hebt nog ${i?.count} AI-acties over deze maand.`)
};

const pl_low_credit_banner = /** @type {(inputs: Low_Credit_BannerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Masz jeszcze ${i?.count} akcji AI w tym miesiącu.`)
};

const fi_low_credit_banner = /** @type {(inputs: Low_Credit_BannerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sinulla on ${i?.count} tekoälytoimintoa jäljellä tässä kuussa.`)
};

const da_low_credit_banner = /** @type {(inputs: Low_Credit_BannerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Du har ${i?.count} AI-handlinger tilbage denne måned.`)
};

const sv_low_credit_banner = /** @type {(inputs: Low_Credit_BannerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Du har ${i?.count} AI-åtgärder kvar denna månad.`)
};

/**
* | output |
* | --- |
* | "You have {count} AI actions left this month." |
*
* @param {Low_Credit_BannerInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const low_credit_banner = /** @type {((inputs: Low_Credit_BannerInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Low_Credit_BannerInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_low_credit_banner(inputs)
	if (locale === "fr") return fr_low_credit_banner(inputs)
	if (locale === "es") return es_low_credit_banner(inputs)
	if (locale === "it") return it_low_credit_banner(inputs)
	if (locale === "nl") return nl_low_credit_banner(inputs)
	if (locale === "pl") return pl_low_credit_banner(inputs)
	if (locale === "fi") return fi_low_credit_banner(inputs)
	if (locale === "da") return da_low_credit_banner(inputs)
	if (locale === "sv") return sv_low_credit_banner(inputs)
	return en_low_credit_banner(inputs)
});